import { createFileRoute } from "@tanstack/react-router";
import { EngagementNotes } from "./-components/stay/engagement-notes";
import { EngagementUpdates } from "./-components/stay/engagement-updates";
import { EngagementVisits } from "./-components/stay/engagement-visits";

export const Route = createFileRoute("/_authenticated/_care/residents/$residentId/engagement")({
  component: EngagementTab,
});

/** The family's part in this resident's life: notes waiting for them, visits, what was shared. */
function EngagementTab() {
  const { residentId } = Route.useParams();
  return (
    <div className="space-y-6">
      <EngagementNotes residentId={residentId} />
      <EngagementVisits residentId={residentId} />
      <EngagementUpdates residentId={residentId} />
    </div>
  );
}
